import { TEventJournalQuery } from '@entities/eventJournal/model/types';
import { useNuqsArrayQueryState } from '@shared/hooks';

interface IUseFilterQueryProps {
    queryKey: TEventJournalQuery;
}

export const useFilterQuery = ({ queryKey }: IUseFilterQueryProps) => {
    const { state, toggleQueryValue, clearQueryValue } = useNuqsArrayQueryState(queryKey);

    const onFilterClickQuery = (value: string) => {
        void toggleQueryValue(value);
    };

    return { state, onFilterClickQuery, clearQueryValue };
};
